import { Vendor } from "@coherehealth/core-platform-api";
import { titleCaseWord, ucfirst } from "./stringUtils";

// Health plan name: Convert SCREAMING_SNAKE_CASE to Title Case + spaces.
// Used to query feature configs and other data.
export const convertHealthPlanEnumToName = (name?: string): string => {
  if (!name) {
    return "";
  }

  const parts = name.split(/_/);

  // Special cases, sorry
  if (name === "MEDICARE_NOVITAS") {
    return "Medicare - Novitas";
  }
  if (name === "HMSA") {
    return "HMSA";
  }
  return ucfirst(parts.map(titleCaseWord).join(" "));
};

// Inverse of convertHealthPlanEnumToName
export const convertHealthPlanNameToEnum = (name: string): string => {
  // Special case
  if (name === "Medicare - Novitas") {
    return "MEDICARE_NOVITAS";
  }
  return name.toUpperCase().replace(/ /g, "_");
};

export function healthPlanSupportsFaxes(healthPlanName: string | undefined) {
  return healthPlanName !== "Oscar";
}

/**
 * NB: DO NOT ADD TO THIS LIST!
 * There should be no reason for you to write a health plan name
 * in code. Don't encourage others to either!
 */
export const HUMANA_HEALTH_PLAN_NAME: Vendor = "Humana";
export const HEALTH_HELP_NAME: Vendor = "HealthHelp";
export const AGADIA_NAME: Vendor = "Agadia";
export const COHERE_NAME: Vendor = "Cohere";
export const GEISINGER_NAME: Vendor = "Geisinger";
export const HEALTH_HELP_V2_NAME: Vendor = "HealthHelpV2";
export const MEDICAL_MUTUAL_OF_OHIO_NAME: Vendor = "Medical Mutual of Ohio";
export const BCBS_SC = "BCBS South Carolina";
/**
 * DON'T DO IT!
 */
